import { googleAppointmentConversionTrackingStorage } from '~/utils/storage/ubieAppStorage';
import { differenceInSeconds } from 'date-fns';

// rwg_tokenは最大30日間保持する
const MAX_DURATION_SECOND = 30 * 24 * 60 * 60;

// action centerから取得できる
const PartnerId = 20002649;

// コンバージョントラッキングに必要なRwgTokenを取得する
// https://developers.google.com/actions-center/verticals/appointments/redirect/integration-steps/conversion-tracking?hl=ja#collecting_the_rwg_token
export function getRwgToken(urlSearchParams: URLSearchParams) {
  const rwgToken = urlSearchParams.get('rwg_token');
  if (rwgToken != null) return decodeURIComponent(rwgToken);
}

// RwgTokenをストレージに保存する
// サンプル実装ではcookieを使用しているが、純粋にストレージとして使いたいだけなので、local storageで実装した
// https://developers.google.com/actions-center/verticals/appointments/redirect/integration-steps/conversion-tracking?hl=ja#persisting_the_rwg_token
//
// 最初にアクションリンクを踏んでからmerchant(医療機関)が変わった場合にその旨もトラッキングAPIに送信する必要があるので、その情報も保存している。
// 詳しくは以下を参照
// https://developers.google.com/actions-center/verticals/appointments/redirect/integration-steps/conversion-tracking?hl=ja#conversion_attribution_requirements
export async function saveRwgToken(merchantId: string, urlSearchParams: URLSearchParams) {
  const rwgToken = getRwgToken(urlSearchParams);

  // todo: rwgTokenがわたってきていないのは通常ではありえないので、何かしら通知したほうがいいかも？
  //  ただし、開発中などに直接予約LPにアクセスする場合はありえるので、通知するならそれの考慮が必要。
  if (rwgToken == null) return;

  const isDebug = urlSearchParams.get('is_ubie_debug') != null;
  const currentData = googleAppointmentConversionTrackingStorage.get();
  if (currentData == null) {
    googleAppointmentConversionTrackingStorage.set({
      rwgToken,
      merchantId,
      createdAt: Date.now(),
      merchantChanged: 2,
      isDebug,
    });
  } else {
    const diffSec = differenceInSeconds(new Date(), new Date(currentData.createdAt));
    if (diffSec > MAX_DURATION_SECOND) {
      // 前回の保存時から30日間を超える場合は、単純に上書きしてしまう
      googleAppointmentConversionTrackingStorage.set({
        rwgToken,
        merchantId,
        createdAt: Date.now(),
        merchantChanged: 2,
        isDebug,
      });
    } else {
      // 30日間以内の場合、販売元が変更しているかどうかをチェックして保存する
      googleAppointmentConversionTrackingStorage.set({
        rwgToken,
        merchantId,
        createdAt: Date.now(),
        merchantChanged: currentData.merchantId !== merchantId ? 1 : 2,
        isDebug,
      });
    }
  }
}

// コンバージョントラッキングにRwgTokenを送信する
// https://developers.google.com/actions-center/verticals/appointments/redirect/integration-steps/conversion-tracking?hl=ja#sending_conversion_data
export async function sendRwgToken() {
  const currentData = googleAppointmentConversionTrackingStorage.get();

  // todo: この状況はありえないはずなので、何かしら通知したほうがいいかも？
  if (currentData == null) return;

  // todo: 環境変数に移動する
  const endpoint = currentData.isDebug
    ? 'https://www.google.com/maps/conversion/debug/collect'
    : 'https://www.google.com/maps/conversion/collect';
  const res = await fetch(endpoint, {
    method: 'POST',
    body: JSON.stringify({
      conversion_partner_id: PartnerId,
      rwg_token: currentData.rwgToken,
      merchant_changed: currentData.merchantChanged,
    }),
  });

  // 送信が成功したかどうかにかかわらずデータは削除しておく
  // 送信失敗時に復旧処理を行えないため（ちゃんとやるならリトライ処理をするほうがよさそう）
  googleAppointmentConversionTrackingStorage.delete();

  if (!res.ok) {
    // todo: sentryに通知するなどしたほうがよいかも？
    console.error(`予約コンバージョントラッキングの送信に失敗: status = ${res.status}, body = ${await res.text}`);
  }
}
